import Webhooks from './webhooks.page';

import { withLayout } from 'layout';

export default withLayout(Webhooks);
